class SiteSearch {
  
  constructor(){
    this.serachField       = document.querySelector('#woocommerce-product-search-field-0');
    this.serachFieldopen       = document.querySelector('#woocommerce-product-search-field-0');
    this.serachFieldBtn = document.querySelector('.widget_product_search form' );
    this._init();
  }
  
  _init(){
    document.addEventListener('DOMContentLoaded', (event) => {
        if(this.serachFieldBtn){
          this.serachFieldBtn.addEventListener('click', 
          this._updateNav.bind(this),
          false
        )};
        if(this.serachFieldopen){
          this.serachFieldopen.addEventListener('click', 
          this._updateNav.bind(this),
          false
        )};
    });
  }

  _updateNav(){
    this._toggleState(this.serachField, 'open', 'closed');
    this._toggleState(this.serachFieldopen, 'open', 'open');
  }

  _toggleState(elem, one, two){
    let newState = elem.getAttribute('data-state') === one ? two : one;
    elem.setAttribute('data-state', newState);
  }

}

export let sitesearch = new SiteSearch();
